export default "__VITE_PUBLIC_ASSET__76db58c6__"